import { observer } from 'mobx-react';
import * as React from 'react';
import { currentUserStore } from '../../CurrentUserStore';
import CurrentHoneybadgerUserReactions from '../../Honeybadger/CurrentHoneybadgerUserReactions';
import { SessionReactions } from '../../Session/Reactions';
import { sessionStore } from '../../Session/Store';
import CurrentUserReactions from '../CurrentUserReactions';
import TimeOutReactions from '../TimeOutReactions';

const AppReactions: React.FC = () => (
  <>
    <SessionReactions store={sessionStore} fireImmediately />
    <TimeOutReactions store={sessionStore} fireImmediately={true} />
    <CurrentUserReactions store={currentUserStore} fireImmediately={true} />
    <CurrentHoneybadgerUserReactions store={currentUserStore} fireImmediately={true} />
  </>
);

export default observer(AppReactions);
